export default __webpack_public_path__ + "static/media/premios_trivia.74b4fe22.png";